import { TableCustomerListType, ApiCustomerType } from './types';
import { getFormattedDate } from '../../helpers/date';

export const filterApiResponse = (
  data: ApiCustomerType[]
): TableCustomerListType =>
  data.map(customer => ({
    key: customer.id,
    id: customer.id,
    customer: {
      id: customer.id,
      type: customer.type,
      name: customer.name,
      status: customer.status,
      createdAt: getFormattedDate(customer.created_at, 'DD/MM/YYYY'),
    },
  }));
